import { apiClient } from "./client";
import type { Role } from "./auth";

export type Language = "uk" | "ru";

export interface Tenant {
  id: string;
  name: string;
  description: string | null;
  timezone: string;
  is_active: boolean;
  created_at: string;
}

export interface TenantWrite {
  name: string;
  description?: string | null;
  timezone?: string;
  is_active?: boolean;
}

export interface AdminUser {
  id: string;
  email: string;
  full_name: string;
  role: Role;
  language: Language;
  is_active: boolean;
  last_login_at: string | null;
  created_at: string;
  tenant_ids: string[];
}

export interface AdminUserCreate {
  email: string;
  full_name: string;
  role: Role;
  language?: Language;
  password: string;
  tenant_ids?: string[];
  is_active?: boolean;
}

export interface AdminUserUpdate {
  full_name?: string;
  role?: Role;
  language?: Language;
  is_active?: boolean;
  new_password?: string;
  tenant_ids?: string[];
}

export const adminUsersApi = {
  // Tenants
  listTenants: () => apiClient.get<Tenant[]>("/admin/tenants").then((r) => r.data),
  createTenant: (b: TenantWrite) =>
    apiClient.post<Tenant>("/admin/tenants", b).then((r) => r.data),
  updateTenant: (id: string, b: Partial<TenantWrite>) =>
    apiClient.put<Tenant>(`/admin/tenants/${id}`, b).then((r) => r.data),

  // Users
  listUsers: () => apiClient.get<AdminUser[]>("/admin/users").then((r) => r.data),
  createUser: (b: AdminUserCreate) =>
    apiClient.post<AdminUser>("/admin/users", b).then((r) => r.data),
  updateUser: (id: string, b: AdminUserUpdate) =>
    apiClient.put<AdminUser>(`/admin/users/${id}`, b).then((r) => r.data),
  deactivateUser: (id: string) =>
    apiClient.delete<{ ok: boolean }>(`/admin/users/${id}`).then((r) => r.data),
};
